import React from "react";
import { FaInfoCircle } from "react-icons/fa";

function InfoIcon() {
  return <FaInfoCircle size={20} style={{ color: "#363a3d", marginRight: "10px" }} />;
}

export default InfoIcon;
